// ─── PER-THREAD LORE — the author's lore for one story or one DM ────────────
// Haley, 2026-10-19: "a lore section for specific RPs and for DMs that can be
// updated with that specific stories lore that an author can update". Stored
// on the thread row (stories.lore / dm_conversations.lore), rendered into the
// CACHED half of that thread's prompt, and ranked above the world's defaults
// inside that thread — the same precedence the community's lore rooms have.
import { supabase } from './supabaseClient.js';

export const THREAD_LORE_MAX = 6000;

const TABLE = { story: 'stories', dm: 'dm_conversations' };

/** The prompt section for a thread's lore; '' when there is none. */
export function formatThreadLore(lore, scope = 'this thread') {
  const text = String(lore || '').trim();
  if (!text) return '';
  return `\n═══ THIS ${scope.toUpperCase()}'S LORE — written by the author for ${scope} only. It is TRUE here and outranks your profile, the world's defaults and anything you would otherwise assume; when it leaves something open, leave it open or ask. ═══\n${text.slice(0, THREAD_LORE_MAX)}\n`;
}

/** Save the author's lore on the thread row. Verified write: the row the database stored is what comes back. */
export async function saveThreadLore(threadType, threadId, lore) {
  const table = TABLE[threadType];
  if (!table || !threadId) return { ok: false, error: 'unknown thread' };
  const value = String(lore || '').trim().slice(0, THREAD_LORE_MAX) || null;
  const { data, error } = await supabase.from(table).update({ lore: value }).eq('id', threadId).select('id, lore');
  if (error) return { ok: false, error: error.message };
  if (!data?.length) return { ok: false, error: 'nothing was updated' };
  return { ok: true, lore: data[0].lore || '' };
}
